export const emallApi = 'web-emall';
export function parseQueryString(url) {
  const params = {};
  const queryString = url.split('?')[1];
  if (queryString) {
    queryString.split('&').forEach(function (part) {
      const keyValuePair = part.split('=');
      const key = decodeURIComponent(keyValuePair[0]);
      const value = keyValuePair[1] ? decodeURIComponent(keyValuePair[1]) : '';
      if (params[key]) {
        params[key] = Array.isArray(params[key]) ? params[key] : [params[key]];
        params[key].push(value);
      } else {
        params[key] = value;
      }
    });
  }
  return params;
}
